import { store } from "../store/configureStore";
import { arrayHelper } from "./arrayHelper";

const API_KEY = "AIzaSyB6aQW4uFg8OuFMHaxBmqDPCvzBGe5vuTg";

const createGoogleImports = (fonts) => {
    let str = "";
    fonts.map(f => {
        if (f.includes(" ")) { f = f.replace(" ", "+"); }
        str += `@import url('https://fonts.googleapis.com/css?family=${f}&display=swap');`;
    });
    return str;
}


export const extractFontsFromJson = (obj) => {
    let cssFonts = "";
    let googleFonts = [];
    let clientFonts = [];
    for (const prop in obj) {
        for (const v in obj[prop]) {
            for (const c in obj[prop][v]) {
                if (c === 'fontFamily') {
                    if (store.getState().cms.fonts.length > 0 && store.getState().cms.fonts.find(f => { return f.name === obj[prop][v][c] })) {
                        const font = store.getState().cms.fonts.find(f => { return f.name === obj[prop][v][c] });
                        if (font) {
                            clientFonts.push(font);
                        }

                    }
                    else {
                        googleFonts.push(obj[prop][v][c]);
                    }

                }
            }
        }
    }
    /*   fonts = [...new Set(fonts)]; */
    cssFonts = googleFonts.length > 0 ? cssFonts + createGoogleImports(googleFonts) : cssFonts;
    cssFonts = clientFonts.length > 0 ? cssFonts + createFontFaces(clientFonts) : cssFonts;
    return cssFonts
}

const createFontFaces = (fonts) => {
    let str = "";
    fonts.map(cf => {
        str += `@font-face{ font-family: ${cf.name}; src: url('${cf.url}'); }`;
    });
    return str;
}

export const insertFonts = (clientFonts) => {
    let cssFonts = "";
    if (clientFonts !== undefined) {
        cssFonts += createFontFaces(clientFonts);
    }
    return cssFonts;
}

export const insertGoogleFonts = (props) => {
    const { template } = props;
    const fonts = template.match(/font-family:(.*?)}/g);
    const clientFonts = store.getState().cms.fonts;

    let str = "";
    const googleFonts = [];
    fonts.map((f, i) => {

        let s = f.substring(0, f.indexOf(';') + 1);
        let q = f.substring(0, f.indexOf('}') + 1);

        let s1 = s.substring(0, s.indexOf(';'));
        let q1 = q.substring(0, q.indexOf('}'));

        if (!q1.includes(';') && q1 !== "" && !q1.includes('inherit')) {
            let font = q1.substring('font-family:'.length, q1.length + 1);
            if (clientFonts !== undefined && !clientFonts.find(f => { return f.name === font })) {
                if (font.includes(" ")) { font = font.replace(" ", "+"); }
                let importStr = `@import url('https://fonts.googleapis.com/css?family=${font}:300,400,700,800&display=swap');`;
                googleFonts.push(importStr);
            }
            else {
                if (font.includes(" ")) { font = font.replace(" ", "+"); }
                let importStr = `@import url('https://fonts.googleapis.com/css?family=${font}:300,400,700,800&display=swap');`;
                googleFonts.push(importStr);
            }

        }
        if (!s1.includes(';') && s1 !== "" && !s1.includes('inherit')) {
            let font = s1.substring('font-family:'.length, s1.length + 1);
            if (clientFonts !== undefined && !clientFonts.find(f => { return f.name === font })) {
                if (font.includes(" ")) { font = font.replace(" ", "+"); }
                let importStr = `@import url('https://fonts.googleapis.com/css?family=${font}:300,400,700,800&display=swap');`;
                googleFonts.push(importStr);
            } else {
                if (font.includes(" ")) { font = font.replace(" ", "+"); }
                let importStr = `@import url('https://fonts.googleapis.com/css?family=${font}:300,400,700,800&display=swap');`;
                googleFonts.push(importStr);
            }
        }
    });

    let unique = [...new Set(googleFonts)];
    unique.map(gf => {
        str += gf + '\n';
    })
    clientFonts !== undefined && clientFonts.map(cf => {
        str += `@font-face{ font-family: ${cf.name}; src: url('${cf.url}')}`;
    })

    return str

}
